import { SET_UTM_SOURCE_SOURCE_TYPE } from 'actions';

export const setUtmSourceSourceType = (utmSource: string) => {
  return { type: SET_UTM_SOURCE_SOURCE_TYPE, utmSource };
};
